import { useMemo } from "react";
import { IdentityDao } from "./IdentityDao";

export const useIdentityDao = (): IdentityDao => {
  return useMemo(() => {
    return new IdentityDao();
  }, []);
};
